import { render, staticRenderFns } from "./CommonMultipleChoice.vue?vue&type=template&id=7cd65595&scoped=true"
import script from "./CommonMultipleChoice.vue?vue&type=script&lang=js"
export * from "./CommonMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./CommonMultipleChoice.vue?vue&type=style&index=0&id=7cd65595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd65595",
  null
  
)

export default component.exports